import { IDnsQueue } from '@modules/customs';

export const dnsQueueGlobalFilter = (data: IDnsQueue[], value: string) => {
  if (!value) {
    return data;
  }

  return data.filter((item) => item.query.find((query) => (query.tracking_no || query.trackingNumber)?.includes(value)));
};
